<template>
  <div class="Page-assemblage">
    <!-- Hero Section -->
    <section class="Hero">
      <h1>Assemblage de Composants Électroniques</h1>
      <p class="Hero-subtitle">
        De la pose manuelle à l’assemblage automatisé, nous réalisons vos cartes électroniques avec précision.
      </p>
    </section>

    <!-- Services d'assemblage -->
    <section class="Services">
      <h2>Nos Services d’Assemblage</h2>
      <div class="ServicesGrid">
        <div class="ServiceCard">
          <div class="ServiceIcon">🤲</div>
          <h3>Assemblage Manuel</h3>
          <p>Montage soigné de prototypes et petites séries par nos techniciens expérimentés.</p>
          <ul>
            <li>Soudure à la main (CMS & traversant)</li>
            <li>Contrôle visuel et électrique</li>
            <li>Montage de composants spéciaux</li>
            <li>Réparation et retouches</li>
          </ul>
        </div>
        <div class="ServiceCard">
          <div class="ServiceIcon">🤖</div>
          <h3>Assemblage Automatisé</h3>
          <p>Production en série avec machines pick & place et fours de refusion.</p>
          <ul>
            <li>Placement rapide CMS</li>
            <li>Refusion contrôlée</li>
            <li>Contrôle AOI (inspection optique)</li>
            <li>Traçabilité des lots</li>
          </ul>
        </div>
        <div class="ServiceCard">
          <div class="ServiceIcon">🧪</div>
          <h3>Tests & Contrôles</h3>
          <p>Vérification fonctionnelle et qualité de chaque carte assemblée.</p>
          <ul>
            <li>Tests électriques</li>
            <li>Inspection visuelle</li>
            <li>Contrôle X-ray (BGA, QFN...)</li>
            <li>Rapport de conformité</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Types d’assemblage -->
    <section class="AssemblyTypes">
      <h2>Types d’Assemblage Proposés</h2>
      <div class="TypesGrid">
        <div class="TypeCard">
          <div class="TypeIcon">🔧</div>
          <h3>Prototypage</h3>
          <div class="TypePrice">Sur devis</div>
          <p>Assemblage rapide de prototypes et préséries</p>
          <ul>
            <li>Délai express possible</li>
            <li>Flexibilité sur les composants</li>
            <li>Montage manuel ou mixte</li>
            <li>Contrôle qualité inclus</li>
          </ul>
          <button class="TypeButton">Demander un devis</button>
        </div>
        <div class="TypeCard featured">
          <div class="TypeIcon">🏭</div>
          <h3>Série Moyenne</h3>
          <div class="TypePrice">À partir de 1,50€/carte</div>
          <p>Assemblage automatisé pour moyennes séries</p>
          <ul>
            <li>Pick & place CMS</li>
            <li>Refusion four industriel</li>
            <li>Contrôle AOI</li>
            <li>Traçabilité des lots</li>
            <li>Délai : 1 à 2 semaines</li>
          </ul>
          <button class="TypeButton">Recommandé</button>
        </div>
        <div class="TypeCard">
          <div class="TypeIcon">🚀</div>
          <h3>Grande Série</h3>
          <div class="TypePrice">Sur devis</div>
          <p>Production industrielle à grande échelle</p>
          <ul>
            <li>Automatisation complète</li>
            <li>Tests en ligne</li>
            <li>Gestion logistique</li>
            <li>Support technique dédié</li>
            <li>Délai selon volume</li>
          </ul>
          <button class="TypeButton">Demander un devis</button>
        </div>
      </div>
    </section>

    <!-- Processus d’assemblage -->
    <section class="Process">
      <h2>Notre Processus d’Assemblage</h2>
      <div class="ProcessSteps">
        <div class="Step">
          <div class="StepNumber">1</div>
          <h3>Réception</h3>
          <p>Réception des PCB et composants</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">2</div>
          <h3>Préparation</h3>
          <p>Programmation des machines et préparation des lots</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">3</div>
          <h3>Assemblage</h3>
          <p>Montage manuel ou automatisé</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">4</div>
          <h3>Contrôle</h3>
          <p>Tests et inspection qualité</p>
        </div>
        <div class="StepArrow">→</div>
        <div class="Step">
          <div class="StepNumber">5</div>
          <h3>Livraison</h3>
          <p>Expédition des cartes assemblées</p>
        </div>
      </div>
    </section>

    <!-- Outils et équipements -->
    <section class="Tools">
      <h2>Équipements & Outils</h2>
      <div class="ToolsGrid">
        <div class="ToolCard">
          <h4>Machines d’assemblage</h4>
          <ul>
            <li>Pick & Place Juki</li>
            <li>Four de refusion ERSA</li>
            <li>Stations de soudage Weller</li>
            <li>Distributeur de pâte à braser</li>
          </ul>
        </div>
        <div class="ToolCard">
          <h4>Contrôle & Test</h4>
          <ul>
            <li>AOI (inspection optique)</li>
            <li>Rayons X</li>
            <li>Testeurs électriques</li>
            <li>Microscope numérique</li>
          </ul>
        </div>
        <div class="ToolCard">
          <h4>Gestion & Traçabilité</h4>
          <ul>
            <li>ERP industriel</li>
            <li>Gestion des lots</li>
            <li>Suivi de production</li>
            <li>Rapports qualité</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- Upload Section -->
    <section class="Upload">
      <h2>Envoyez votre dossier d’assemblage</h2>
      <div class="UploadArea">
        <div class="UploadBox">
          <div class="UploadIcon">📦</div>
          <h3>Glissez vos fichiers ici</h3>
          <p>Formats acceptés : .bom, .pos, .zip, .rar, .csv</p>
          <p>Taille max : 50 MB par fichier</p>
          <button class="UploadButton">Parcourir les fichiers</button>
        </div>
        <div class="FileTypes">
          <h4>Fichiers nécessaires :</h4>
          <div class="FileTypesList">
            <span class="FileType">BOM (Bill of Materials)</span>
            <span class="FileType">Fichier de placement (.pos, .csv)</span>
            <span class="FileType">Gerber PCB</span>
            <span class="FileType">Plan d’assemblage</span>
            <span class="FileType">Fichiers ZIP/RAR</span>
          </div>
        </div>
      </div>
    </section>

    <!-- CTA Section -->
    <section class="CTA">
      <div class="CTAContent">
        <h2>Besoin d’un devis pour l’assemblage ?</h2>
        <p>Contactez-nous pour une étude rapide de votre projet</p>
        <div class="CTAButtons">
          <button class="CTAButton primary">Demander un Devis</button>
          <button class="CTAButton secondary">Nous Contacter</button>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PageAssemblage'
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@700;400&display=swap');

.Page-assemblage {
  min-height: 100vh;
  font-family: 'Montserrat', Arial, sans-serif;
  color: #fff;
}

/* Hero Section */
.Hero {
  text-align: left;
  padding: 4rem 2rem;
}
.Hero h1 {
  font-family: deonstudio;
  font-size: 3rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);
}
.Hero-subtitle {
  font-size: 1.3rem;
  color: var(--text-muted);
  max-width: 600px;
  line-height: 1.6;
}

/* Services Section */
.Services {
  padding: 4rem 2rem;
  max-width: 1200px;
  margin: 0 auto;
}
.Services h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.ServicesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
  margin-bottom: 2rem;
}
.ServiceCard {
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  padding: var(--spacing-lg);
  min-height: 320px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  transition: all var(--transition-normal);
  position: relative;
  overflow: hidden;
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
}
.ServiceCard:hover {
  transform: translateY(-8px);
  box-shadow: 0 8px 32px rgba(118, 153, 212, 0.2);
}
.ServiceIcon {
  font-size: 3rem;
  text-align: center;
  margin-bottom: 1rem;
  filter: grayscale(0.3);
}
.ServiceCard h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  font-size: 1.4rem;
  margin-bottom: 1rem;
  text-align: center;
}
.ServiceCard p {
  color: #bfc9e0;
  margin-bottom: 1.5rem;
  line-height: 1.6;
}
.ServiceCard ul {
  list-style: none;
  padding: 0;
}
.ServiceCard li {
  color: var(--text-muted);
  padding: 0.3rem 0;
  position: relative;
  padding-left: 1.5rem;
}
.ServiceCard li::before {
  content: "▸";
  color: var(--text-secondary);
  position: absolute;
  left: 0;
}

/* Assembly Types Section */
.AssemblyTypes {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
  margin: 2rem 0;
}
.AssemblyTypes h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.TypesGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}
.TypeCard {
  background: white;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  position: relative;
  transition: all 0.3s ease;
  border: 2px solid transparent;
}
.TypeCard.featured {
  border-color: var(--text-secondary);
  transform: scale(1.05);
}
.TypeCard:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}
.TypeIcon {
  font-size: 3rem;
  margin-bottom: 1rem;
}
.TypeCard h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}
.TypePrice {
  font-size: 1.5rem;
  font-weight: bold;
  color: var(--bg-secondary);
  margin-bottom: 1rem;
}
.TypeCard p {
  color: #666;
  margin-bottom: 1.5rem;
}
.TypeCard ul {
  list-style: none;
  padding: 0;
  text-align: left;
  margin-bottom: 2rem;
}
.TypeCard li {
  color: #555;
  padding: 0.3rem 0;
  position: relative;
  padding-left: 1.5rem;
}
.TypeCard li::before {
  content: "✓";
  color: var(--text-secondary);
  position: absolute;
  left: 0;
  font-weight: bold;
}
.TypeButton {
  background: var(--bg-secondary);
  color: white;
  border: none;
  padding: 0.8rem 2rem;
  border-radius: 6px;
  cursor: pointer;
  font-family: deonstudio;
  transition: all 0.3s ease;
  width: 100%;
}
.TypeButton:hover {
  background: var(--text-secondary);
  transform: translateY(-2px);
}

/* Process Section */
.Process {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
}
.Process h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.ProcessSteps {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 2rem;
  max-width: 1000px;
  margin: 0 auto;
}
.Step {
  text-align: center;
  flex: 1;
  min-width: 180px;
}
.StepNumber {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: var(--text-secondary);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  margin: 0 auto 1rem auto;
  font-family: deonstudio;
}
.Step h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 0.5rem;
}
.Step p {
  color: #bfc9e0;
  font-size: 0.9rem;
  line-height: 1.4;
}
.StepArrow {
  font-size: 2rem;
  color: var(--text-secondary);
  font-weight: bold;
}

/* Tools Section */
.Tools {
  padding: 4rem 2rem;
  max-width: 1000px;
  margin: 0 auto;
}
.Tools h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.ToolsGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
}
.ToolCard {
  border-radius: 12px;
  padding: 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
}
.ToolCard h4 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 1rem;
  text-align: center;
}
.ToolCard ul {
  list-style: none;
  padding: 0;
}
.ToolCard li {
  color: var(--text-muted);
  padding: 0.4rem 0;
  text-align: center;
  border-bottom: 1px solid rgba(118, 153, 212, 0.1);
}
.ToolCard li:last-child {
  border-bottom: none;
}

/* Upload Section */
.Upload {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
  margin: 2rem 0;
}
.Upload h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  text-align: center;
  margin-bottom: 3rem;
  color: var(--text-secondary);
}
.UploadArea {
  max-width: 800px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
}
.UploadBox {
  background: white;
  border: 3px dashed var(--text-secondary);
  border-radius: 12px;
  padding: 3rem 2rem;
  text-align: center;
  transition: all 0.3s ease;
}
.UploadBox:hover {
  border-color: var(--bg-secondary);
  background: #f8f9ff;
}
.UploadIcon {
  font-size: 4rem;
  margin-bottom: 1rem;
}
.UploadBox h3 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 1rem;
}
.UploadBox p {
  color: #666;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}
.UploadButton {
  background: var(--bg-secondary);
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 6px;
  cursor: pointer;
  font-family: deonstudio;
  transition: all 0.3s ease;
}
.UploadButton:hover {
  background: var(--text-secondary);
}
.FileTypes h4 {
  font-family: deonstudio;
  color: var(--text-secondary);
  margin-bottom: 1rem;
}
.FileTypesList {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.FileType {
  background: white;
  color: var(--text-secondary);
  padding: 0.5rem 1rem;
  border-radius: 6px;
  font-size: 0.9rem;
  border: 1px solid var(--text-secondary);
}

/* CTA Section */
.CTA {
  padding: 4rem 2rem;
  background-color: var(--bg-tertiary);
  border-radius: var(--radius-small);
  box-shadow: 5px 5px 10px #d9d9d9, -5px -5px 10px #ffffff;
  text-align: center;
  margin-bottom: 2%;
}
.CTAContent h2 {
  font-family: deonstudio;
  font-size: 2.5rem;
  margin-bottom: 1rem;
  color: var(--text-secondary);
}
.CTAContent p {
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: var(--text-muted);
}
.CTAButtons {
  display: flex;
  gap: 1rem;
  justify-content: center;
  flex-wrap: wrap;
}
.CTAButton {
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  border-radius: 8px;
  cursor: pointer;
  font-family: deonstudio;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0,0,0,0.2);
}
.CTAButton.primary {
  background: var(--bg-secondary);
  color: white;
}
.CTAButton.secondary {
  background: transparent;
  color: var(--text-secondary);
  border: 2px solid var(--text-secondary);
}
.CTAButton:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0,0,0,0.3);
}
.CTAButton.primary:hover {
  background: var(--text-secondary);
}
.CTAButton.secondary:hover {
  background: var(--text-secondary);
  color: white;
}

/* Responsive amélioré */
@media (max-width: 1024px) {
  .ServicesGrid,
  .TypesGrid,
  .ToolsGrid {
    grid-template-columns: 1fr 1fr;
  }
  .UploadArea {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
}
@media (max-width: 768px) {
  .Hero {
    padding: 2rem 1rem;
  }
  .Hero h1 {
    font-size: 2rem;
  }
  .Hero-subtitle {
    font-size: 1rem;
  }
  .Services,
  .AssemblyTypes,
  .Process,
  .Tools,
  .Upload,
  .CTA {
    padding: 2rem 1rem;
  }
  .ServicesGrid,
  .TypesGrid,
  .ToolsGrid {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }
  .ServiceCard,
  .TypeCard,
  .ToolCard {
    padding: 1.2rem;
    min-height: unset;
  }
  .TypeCard.featured {
    transform: none;
  }
  .ProcessSteps {
    flex-direction: column;
    gap: 1.2rem;
  }
  .StepArrow {
    display: none;
  }
  .UploadArea {
    grid-template-columns: 1fr;
    gap: 1.2rem;
  }
  .UploadBox {
    padding: 2rem 1rem;
  }
  .CTAButtons {
    flex-direction: column;
    gap: 1rem;
  }
  .CTAButton {
    width: 100%;
    min-width: 0;
    font-size: 1rem;
    padding: 0.8rem 1rem;
  }
}
@media (max-width: 480px) {
  .Hero h1 {
    font-size: 1.3rem;
  }
  .Hero-subtitle {
    font-size: 0.95rem;
  }
  .ServiceIcon,
  .TypeIcon,
  .UploadIcon {
    font-size: 2rem;
  }
  .ServiceCard,
  .TypeCard,
  .ToolCard {
    padding: 0.8rem;
  }
  .StepNumber {
    width: 40px;
    height: 40px;
    font-size: 1rem;
  }
  .UploadBox {
    padding: 1rem 0.5rem;
  }
  .CTAContent h2 {
    font-size: 1.2rem;
  }
  .CTAButton {
    font-size: 0.95rem;
    padding: 0.7rem 0.8rem;
  }
}
</style>